import request from '@/http/request'
import {
    updateInfo,
    getServerTime
} from '@/http/api'

export const getCurrentTime = (data) => {
    return request({
        url: getServerTime,
        data
    })
}

export const updateInfoFn = (data) => {
    return request({
        url: updateInfo,
        data
    })
}